import { render, staticRenderFns } from "./4gStatusBar.vue?vue&type=template&id=e783a3b0&scoped=true&"
import script from "./4gStatusBar.vue?vue&type=script&lang=js&"
export * from "./4gStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./4gStatusBar.vue?vue&type=style&index=0&id=e783a3b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e783a3b0",
  null
  
)

export default component.exports